import { Link } from 'react-router-dom';
import { articleCardData } from '@/mocks/articles';

export default function SeoContentBlock() {
  return (
    <section id="articles" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100/70 mb-5">
            <span className="text-xs font-medium text-secondary-700 tracking-wide">Guides &amp; Articles</span>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            Everything You Need To Know About Sugargoo
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            In-depth guides and resources to help you become a Sugargoo spreadsheet expert.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {articleCardData.map((guide) => (
            <Link
              key={guide.image}
              to={`/articles/${guide.slug}`}
              className="group flex flex-col rounded-2xl bg-background-100 border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer overflow-hidden"
            >
              <div className="w-full h-44 overflow-hidden">
                <img
                  src={guide.image}
                  alt={guide.imageAlt}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5 flex-1 flex flex-col">
                <h3 className="font-heading text-base font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors mb-2">
                  {guide.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed mb-4 flex-1">{guide.desc}</p>
                <span className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 group-hover:text-primary-700 transition-colors whitespace-nowrap">
                  Read Full Guide
                  <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}